import React from "react";

import { useNavigate } from "react-router-dom";

import { ChevronLeft } from "lucide-react";

import { Button } from "~/components/ui/button";

const ClientNotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="flex h-64 items-center justify-center">
      <div className="text-center">
        <h2 className="text-xl font-semibold">Cliente no encontrado</h2>
        <p className="mt-2 text-muted-foreground">
          El cliente que busca no existe o ha sido eliminado.
        </p>
        <Button className="mt-4" onClick={() => navigate("/clients")}>
          <ChevronLeft className="mr-2 h-4 w-4" />
          Volver a la lista de clientes
        </Button>
      </div>
    </div>
  );
};

export default ClientNotFound;
